import MainCard from "components/MainCard";
import { Chip } from "@mui/material";
import { useState } from "react";

const StatusInfoCard = ({ title, cardType = 'empty', children }) => {
  const className =
    cardType === 'empty'
      ? 'charts_card'
      : `charts_card ${cardType}`;

  return (
    <MainCard content={false} className="squarebox">
      <div className="alert_phrase">
        <div style={{ padding: 0, textAlign: "center" }}>
          <Chip label={title} color="primary" />
        </div>

        <div className={className}>
          {children}
        </div>
      </div>
    </MainCard>
  );
};

export default StatusInfoCard;